<!-- Builder End -->
<div id="{{position}}"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="(loadingData$ | async)">
    <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null" data-aos-duration="1100"
      class="app-header-background inline-gradient contact-form-header"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="app-header-section pt-20 global-max-width">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex class="contact-text" [attr.data-aos]="textAnimation ? textAnimation : null"
            data-aos-duration="1100">
            <div class="app-header-headline">
              <h1
                [ngStyle]="{  'font-family': titleFontFamily ? titleFontFamilyName : '' ,'text-align': textAlign, 'color': titleColor?titleColor:textColor , 'font-weight': fontWeight }"
                class="mat-h1" [ngClass]="[titleSize]" [innerHtml]="title | safeHtml"> </h1>
              <h2 [ngStyle]="{  'text-align': textAlign,'color': textColor }" [innerHtml]="text | safeHtml"
                [class]="textSize"></h2>
              <div>
                <div *ngIf="email" [class]="textSize + ' contact-info'"
                  [ngStyle]="{ 'text-align': textAlign,'text-align': textAlign, 'color': textColor }">
                  <mat-icon [ngStyle]="{ 'text-align': 'center','background-color': textColor }"
                    class="sidenav-close-icon">mail</mat-icon> {{email}}
                </div>
                <div *ngIf="phone" [class]="textSize + ' contact-info'"
                  [ngStyle]="{ 'text-align': textAlign,'text-align': textAlign, 'color': textColor }">
                  <mat-icon [ngStyle]="{ 'text-align': 'center','background-color': textColor }"
                    class="sidenav-close-icon">phone</mat-icon> {{phone}}
                </div>
                <div *ngIf="displayNetworks && isSocialMediaExist()" [class]="textSize + ' networks-info'"
                  [ngStyle]="{ 'text-align': textAlign, 'color': textColor }">
                  Follow us on :
                  <a *ngIf="socialNetworks.facebook" [href]="socialNetworks.facebook | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/facebook-16.svg"
                      alt="facebook">
                  </a>

                  <a *ngIf="socialNetworks.twitter" [href]="socialNetworks.twitter | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">

                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/twitter-16.svg"
                      alt="twitter">
                  </a>

                  <a *ngIf="socialNetworks.instagram" [href]="socialNetworks.instagram | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/instagram-16.svg"
                      alt="instagram">
                  </a>

                  <a *ngIf="socialNetworks.youtube" [href]="socialNetworks.youtube | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/youtube-16.svg"
                      alt="youtube">
                  </a>

                  <a *ngIf="socialNetworks.pinterest" [href]="socialNetworks.pinterest" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/pinterest-16.svg"
                      alt="pinterest">
                  </a>

                  <a *ngIf="socialNetworks.vkontakte" href="https://www.vk.com/socialbakers | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/vkontakte-16.svg"
                      alt="vkontakte">
                  </a>

                  <a *ngIf="socialNetworks.linkedin" [href]="socialNetworks.linkedin | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/linkedin-16.svg"
                      alt="linkedin">
                  </a>

                  <a *ngIf="socialNetworks.snapchat" [href]="socialNetworks.snapchat | safeUrl" target="_blank"
                    rel="noopener noreferrer" class="footer-nw__icon">
                    <img src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/social/snapchat-16.svg"
                      alt="snapchat">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div fxFlex [attr.data-aos]="formAnimation ? formAnimation : null" data-aos-duration="1100">
            <div class="try-form-nw">
              <form [formGroup]="contactFormGroup">
                <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
                <div>
                  <mat-form-field>
                    <input matInput placeholder="jeams" (input)="isFormInvalid()" formControlName="name">
                    <mat-label>{{nameField}}</mat-label>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <input matInput placeholder="jeams@example.com" (input)="isFormInvalid()" formControlName="email">
                    <mat-label>{{emailField}}</mat-label>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <textarea matInput placeholder="{{messageField}}" (input)="isFormInvalid()"
                      formControlName="message"></textarea>
                    <mat-label>{{messageField}}</mat-label>
                  </mat-form-field>
                </div>
                <div *ngIf="privacyPolicyExist">
                  <p class="small-legend">
                    <input type="checkbox" id="consent-form" formControlName="consent">
                    <ng-container *ngIf="privacyPolicyExist">
                      <label for="consent-form" class="contact-label" (click)="setConsentChecked()">
                        <a class="privacy-link" [href]="privacyPolicyLink" target="_blank">{{consentText}}</a>
                      </label>
                    </ng-container>
                    <ng-container *ngIf="!privacyPolicyExist">
                      <label for="consent-form" class="contact-label" (click)="setConsentChecked()">
                        {{consentText}}
                      </label>
                    </ng-container>
                  </p>
                </div>
                <div>
                  <div class="app-header-start" *ngIf="!(loading$ | async)">
                    <button (click)="submitForm()" class="btn-large" mat-raised-button color="primary" tabindex="0"
                      aria-disabled="false" [disabled]="isFormInvalid()" [attr.aria-label]="buttonText"> {{ buttonText
                      }}
                    </button>
                  </div>
                  <div class="text-center loading-form" *ngIf="(loading$ | async)">
                    <mat-spinner color="accent" [diameter]="40"></mat-spinner>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>